{
  "headings": {
    "start": "Démarrer",
    "end": "Fin",
    "duration": "Dur.",
    "zero": "Zéro +/-",
    "activity": "Activité",
    "location_space": "Lieu/Espace"
  },
  "actions": {
    "insert_row_below": "Insérer la ligne ci-dessous",
    "insert_row_below_alt": "Une icône affichant la ligne d'insertion ci-dessous",
    "insert_row_above": "Insérer la ligne ci-dessus",
    "insert_row_above_alt": "Une icône affichant la ligne d'insertion au-dessus",
    "export_as_excel": "Exporter au format Excel"
  },
  "activity": {
    "start": "commence",
    "zero": "HEURE ZÉRO"
  },
  "deleting": {
    "deleting_affects_all_instances": "La suppression concerne toutes les instances",
    "delete_activity_description_1": "La suppression de cette activité supprimera également toutes les instances où elle est configurée pour se répéter les autres jours",
    "delete_activity_description_2": "Si vous préférez simplement modifier les paramètres de répétition au lieu de les supprimer, cliquez sur la colonne de démarrage"
  },
  "add": {
    "Event unit": "Ajouter un élément programmé",
    "Activity": "Ajouter une activité"
  },
  "done": "Terminé",
  "export_form": {
    "title": "Exporter le DCAS",
    "days_to_export": "Jours pour exporter",
    "all_days": "Tous les jours",
    "all_days_desc": "Exportez tous les tableaux DCAS pour ce lieu dans un seul fichier Excel",
    "selected_day": "Jour sélectionné",
    "selected_day_desc": "Exporter le DCAS sélectionné vers un fichier Excel"
  }
}